import { render } from "./TwilioSencondColView.vue?vue&type=template&id=be3d7a1a"
import script from "./TwilioSencondColView.vue?vue&type=script&lang=js"
export * from "./TwilioSencondColView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__